import { AxiosError } from 'axios';

/**
 * Checks to see if the error `e` is an AxiosError, Error, or string.
 * @param e Unknown error in a `catch` block.
 * @returns an object with error information.
 */
const formatError = (e: unknown): object => {
  if (e instanceof AxiosError) return (e as AxiosError).toJSON();
  if (e instanceof Error) return e as Error;
  if (typeof e === 'string') return new Error(e);
  return {};
};

export { formatError };
